import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import { Avatar, Box, keyframes } from '@mui/material'
import React from 'react'
import Markdown from 'react-markdown'

import { ChatMessage } from '../../types/chat'

const slideIn = keyframes`
    from { opacity: 0; transform: translateY(10px) scale(0.96); }
    to { opacity: 1; transform: translateY(0) scale(1); }
`

interface ChatBubbleProps {
    message: ChatMessage
}

export const ChatBubble = ({ message }: ChatBubbleProps) => {
    const isUser = message.role === 'user'

    return (
        <Box
            sx={{
                display: 'flex',
                gap: '8px',
                maxWidth: '88%',
                alignSelf: isUser ? 'flex-end' : 'flex-start',
                flexDirection: isUser ? 'row-reverse' : 'row',
                animation: `${slideIn} 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) both`,
            }}
            data-test={`chat-bubble-${message.role}`}
        >
            {!isUser && (
                <Avatar
                    sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '8px',
                        backgroundColor: 'primary.main',
                        marginTop: '2px',
                    }}
                >
                    <SmartToyOutlinedIcon sx={{ fontSize: 16, color: 'secondary.main' }} />
                </Avatar>
            )}

            <Box
                sx={{
                    padding: '10px 14px',
                    fontSize: '13.5px',
                    lineHeight: 1.55,
                    wordBreak: 'break-word',
                    ...(isUser
                        ? {
                              backgroundColor: 'secondary.main',
                              color: 'primary.dark',
                              borderRadius: '14px 4px 14px 14px',
                              fontWeight: 450,
                          }
                        : {
                              backgroundColor: '#f0f4f8',
                              color: 'text.primary',
                              borderRadius: '4px 14px 14px 14px',
                          }),
                }}
            >
                {isUser ? (
                    message.content
                ) : (
                    <Markdown
                        components={{
                            p: ({ children }) => <p style={{ margin: '4px 0' }}>{children}</p>,
                            ul: ({ children }) => <ul style={{ margin: '4px 0', paddingLeft: '18px' }}>{children}</ul>,
                            ol: ({ children }) => <ol style={{ margin: '4px 0', paddingLeft: '18px' }}>{children}</ol>,
                            li: ({ children }) => <li style={{ margin: '2px 0' }}>{children}</li>,
                            strong: ({ children }) => <strong style={{ fontWeight: 600 }}>{children}</strong>,
                        }}
                    >
                        {message.content}
                    </Markdown>
                )}
            </Box>
        </Box>
    )
}
